<template>
  <!-- 道路监控 -->
  <div>
    <div id="bk1" style="display: none" class="bk1"></div>
    <div id="openImg" style="display: none" class="openImg">
      <div class="a" @click="open()"></div>
      <div class="all">
        <span>资料下载</span>
        <table>
          <tr>
            <th>文件名称</th>
            <th>文件格式</th>
            <th>文件大小</th>
            <th>操作</th>
          </tr>
          <tr v-for="(person, index) in arr" :key="index">
            <td>
              <div>{{ person.fileName }}</div>
            </td>
            <td>
              <div>{{ person.fileFormat }}</div>
            </td>
            <td>
              <div>{{ person.fileSize }}</div>
            </td>
            <td>
              <img
                @click="download(person.url, person.fileName)"
                src="../assets/img/icon_download_mob.png"
                alt=""
              />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="bk"></div>
    <div class="top">
      <div class="title">道路监控</div>
      <div class="content">
        般极活性济众己率况八史次等较音与县断青话号选子次成流加约元派产王日线消精军知比口门对每眼形过政保经同改金特极近那性京段元物土机亲气细调治。
      </div>
      <div class="smart">SMART</div>
    </div>
    <div class="topImg"></div>
    <div class="cecurity">
      <div class="title">道路监控</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="cecurityImg"></div>
    <div class="cecurity2">
      <div class="title">道路监控</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="cecurity2Img"></div>
    <div class="bottom">
      <div class="title">道路监控</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="phone">联系电话：0755-83932176</div>
    <div class="address">地址：深圳市盐田区沙头角深盐路保发大厦5楼整层</div>
    <!-- <div class="down" @click="open()">
      <span>下载资源</span>
      <img src="../assets/img/icon_more.svg" alt="" />
    </div> -->
    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'security',
  data () {
    return {
      arr: []
    }
  },
  mounted () {
    this.toggle()
  },
  methods: {
    //     downloadFile(fileName, fileUrl) {
    //       if (!fileUrl) {
    //         return;
    //       }
    //       let url = window.URL.createObjectURL(new Blob([fileUrl]));
    //       let link = document.createElement('a');
    //       link.style.display = 'none';
    //       link.href = url;
    //       link.setAttribute('download', fileName);
    //       document.body.appendChild(link);
    //       link.click();
    //     },
    //     downloadImage (imgsrc, name) {
    //       var image = new Image();
    //       image.setAttribute("crossorigin", "anonymous");
    //       image.onload = function () {
    //         var canvas = document.createElement("canvas");
    //         canvas.width = image.width;
    //         canvas.height = image.height;
    //         var context = canvas.getContext("2d");
    //         context.drawImage(image, 0, 0, image.width, image.height);
    //         var url = canvas.toDataURL("image/png");
    //         var a = document.createElement("a");
    //         var event = new MouseEvent("click");
    //         a.download = name
    //         a.href = url;
    //         a.dispatchEvent(event);
    //       };
    //       image.src = imgsrc + '?time=' + Date.now();
    //     },
    //     downloadFiles(urlimg, name) {//url是路径，name是要更改的下载名称

    //  let link = document.createElement('a')
    //  let url =  urlimg
    //  // 这里是将url转成blob地址，
    //  fetch(url,{mode:'cors'}).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
    //     link.href = URL.createObjectURL(blob)
    //     link.download = name//此处的name是下载的名称
    //     document.body.appendChild(link)
    //     link.click()
    // })

    // },
    handleClick () {
      let url =
        'https://www.szce.com/api/files/2022/10/27/1666870968354avatar.jpg'
      axios.get(url).then(res => {
        console.log(res)
      })
    },
    open () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > 0) {
        document.documentElement.scrollTop = document.body.scrollTop = 0
      }
      var nowStatus = document.getElementById('bk1')
      var bkStatus = document.getElementById('openImg')
      console.log('=======' + nowStatus.style.display)
      if (nowStatus.style.display == 'none') {
        console.log('進來none')
        nowStatus.style.display = 'block'
        bkStatus.style.display = 'block'
      } else {
        console.log('block')
        nowStatus.style.display = 'none'
        bkStatus.style.display = 'none'
      }
    },
    toggle () {
      this.request.get('/information/2', {}).then(res => {
        console.log(res.data.data)
        this.arr = res.data.data
      })
    },

    //转换成base64
    //  DOWLOAD_FILE (url, fileName) {
    //   fetch(url).then(res => res.blob().then(blob => {
    //     var a = document.createElement('a')
    //     a.href = window.URL.createObjectURL(blob)
    //     a.download = fileName
    //     a.click()
    //     window.URL.revokeObjectURL(url)
    //   }))
    // },
    // download(url,fileName){
    //           window.open('https://www.szce.com/api/common/download/'+fileName);},

    // download2(url){
    //     console.log(url+"=====")
    //     const xhr = new XMLHttpRequest();

    //     xhr.open('GET',url);
    //     xhr.responseType='blob'
    //     xhr.send()
    //     xhr.onload=function(){
    //         const fileBlob = xhr.response
    //         console.log(fileBlob)
    //         //将blob 转成url地址
    //         const fileurl = URL.createObjectURL(fileBlob)
    //         console.log(fileurl)
    //     }
    // },

    // async openDownload(urls, name) {
    //       const link = urls;
    //       console.log(link)
    //       const files = link.split('.');
    //       const type = files[files.length - 1];
    //       const x = new XMLHttpRequest();
    //       if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) { // 图片
    //         const image = await this.getBase64Image(link);
    //         x.open('GET', image, true);
    //         console.log('==============')
    //       } else { // 非图片
    //         x.open('GET', link, true);
    //       }

    //       x.responseType = 'blob';
    //       x.onload = function () {
    //         const url = window.URL.createObjectURL(x.response);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = name || '';
    //         a.click();
    //       };
    //       x.send();
    //     },
    //     // 图片转base64
    //     getBase64Image(img) {
    //       return new Promise((resolve, reject) => {
    //         if (!img) {
    //           reject(new Error(null));
    //         }
    //         const canvas = document.createElement('canvas');
    //         const image = new Image();
    //         image.setAttribute('crossOrigin', 'anonymous');
    //         image.src = `${img}?v=${Math.random()}`;
    //         image.onload = () => {
    //           canvas.width = image.width;
    //           canvas.height = image.height;
    //           const ctx = canvas.getContext('2d');
    //           ctx.drawImage(image, 0, 0, image.width, image.height);
    //           const ext = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase();
    //           resolve(canvas.toDataURL(`image/${ext}`));
    //         };
    //         image.error = () => {
    //           reject(new Error(null));
    //         };
    //       });
    //     },
    //  downloadImg(url,name, quality = 0.9) {
    // 			this.pathToBase64(url, quality).then(res => {
    // 				const link = document.createElement("a");
    // 				link.href = res;
    // 				link.setAttribute("download", name);
    // 				document.body.appendChild(link);
    // 				link.click();
    // 				link.remove();
    // 			}).catch(err => {
    // 				console.log(err);
    // 			})
    // 		},
    //          pathToBase64(url, quality = 1, width = 1, height = 1) {
    // 			return new Promise((resolve, reject) => {
    // 				let image = new Image();
    // 				image.onload = function() {
    // 					let canvas = document.createElement('canvas');
    // 					canvas.width = image.width / width;
    // 					canvas.height = image.height / height;
    // 					canvas.getContext('2d').drawImage(image, 0, 0);
    // 					let result = canvas.toDataURL('image/jpeg', quality)
    // 					resolve(result);
    // 				};
    // 				image.setAttribute("crossOrigin", 'Anonymous');
    // 				image.src = url
    // 				image.onerror = () => {
    // 					reject(new Error('urlToBase64 error'));
    // 				};
    // 			})
    // 		},
    // // 点击下载附件
    // downLoad(fileLinkUrl, f_name) {
    //     //fileLinkUrl图片路径
    //    //f_name：图片名称（可以自己随便取）

    //       const url = fileLinkUrl;
    //       console.log(url);
    //       var xmlhttp;
    //       xmlhttp = new XMLHttpRequest(); //用于在后台与服务器交换数据
    //       xmlhttp.open("GET", url); //语法  open(method,url,async)
    //       xmlhttp.header("Access-Control-Allow-Origin", "*");
    //     //   xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
    //       xmlhttp.responseType = "blob";
    //       xmlhttp.onload = function () {
    //         //处理返回的数据
    //         if (this.status == 200) {
    //           var blob = this.response;
    //           var link = document.createElement("a");
    //           link.href = window.URL.createObjectURL(blob); //图片地址
    //           link.setAttribute("download", f_name);
    //           document.body.appendChild(link);
    //           link.click();
    //           link.style.display = "none";
    //           document.body.removeChild(link);
    //         }
    //       };
    //       xmlhttp.send();
    //     },

    // downloadfile(url, strFileName) {
    //              var xmlHttp = null;
    //              var strMimeType = this.getFileType(url)
    //              if (window.ActiveXObject) {
    //                  // IE6, IE5 浏览器执行代码
    //                  xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
    //              } else if (window.XMLHttpRequest) {
    //                  // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
    //                  xmlHttp = new XMLHttpRequest();
    //              }
    //              //2.如果实例化成功，就调用open（）方法：
    //              if (xmlHttp != null) {
    //                  xmlHttp.open("get", url, true);
    //                  xmlHttp.responseType = 'blob';//关键
    //                  xmlHttp.send();
    //                  xmlHttp.onreadystatechange = doResult; //设置回调函数
    //             }
    //              function doResult() {
    //                  if (xmlHttp.readyState == 4) { //4表示执行完成
    //                      if (xmlHttp.status == 200) { //200表示执行成功
    //                          download(xmlHttp.response, strFileName, strMimeType);
    //                      }
    //                  }
    //              }
    //          },

    //           getFileType(fileName) {
    //      // 后缀获取
    //      let suffix = '';
    //      // 获取类型结果
    //      let result = '';
    //      try {
    //          const flieArr = fileName.split('.');
    //          suffix = flieArr[flieArr.length - 1];
    //      } catch (err) {
    //          suffix = '';
    //      }
    //      // fileName无后缀返回 false
    //      if (!suffix) { return false; }
    //      suffix = suffix.toLocaleLowerCase();
    //      // 图片格式
    //      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
    //      // 进行图片匹配
    //      result = imglist.find(item => item === suffix);
    //      if (result) {
    //          return 'image';
    //      }
    //      // 匹配txt
    //      const txtlist = ['txt'];
    //      result = txtlist.find(item => item === suffix);
    //      if (result) {
    //          return 'txt';
    //      }
    //      // 匹配 excel
    //      const excelist = ['xls', 'xlsx'];
    //      result = excelist.find(item => item === suffix);
    //      if (result) {
    //          return 'excel';
    //      }
    //      // 匹配 word
    //      const wordlist = ['doc', 'docx'];
    //      result = wordlist.find(item => item === suffix);
    //      if (result) {
    //          return 'word';
    //      }
    //      // 匹配 pdf
    //      const pdflist = ['pdf'];
    //      result = pdflist.find(item => item === suffix);
    //      if (result) {
    //          return 'pdf';
    //      }
    //      // 匹配 ppt
    //      const pptlist = ['ppt', 'pptx'];
    //      result = pptlist.find(item => item === suffix);
    //      if (result) {
    //          return 'ppt';
    //      }
    //      // 匹配 视频
    //      const videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
    //      result = videolist.find(item => item === suffix);
    //      if (result) {
    //          return 'video';
    //      }
    //      // 匹配 音频
    //      const radiolist = ['mp3', 'wav', 'wmv'];
    //      result = radiolist.find(item => item === suffix);
    //      if (result) {
    //          return 'radio';
    //      }
    //      // 其他 文件类型
    //      return 'other';
    //  }

    // download(url, fileName) {
    //   window.URL = window.URL || window.webkitURL;
    //   let a = document.createElement("a");
    //   let blob = new Blob([url]);
    //   // 通过二进制文件创建url
    //   let url2 = window.URL.createObjectURL(blob);
    //   a.href = url2;
    //   a.download = fileName;
    //   a.click();
    //   // 销毁创建的url
    //   window.URL.revokeObjectURL(url2);
    // },
    download (url, fileName) {
      window.open('https://www.szce.com/api/common/download/' + fileName)
    }

    //会直接预览
    // const element = document.createElement('a');
    // element.setAttribute("href",url)
    // element.setAttribute("download",fileName)
    // console.log(element.href + "=============href")
    // element.click();

    // var event = new MouseEvent('click')
    // element.dispatchEvent(event)
    // element.setAttribute('download', fileName);
    // let binaryData = [];
    // binaryData.push(url);
    // element.setAttribute('href', window.URL.createObjectURL(new Blob(binaryData)));
    // document.body.appendChild(element);
    // element.click();
    // document.body.removeChild(element);

    // window.open(url);
    // }
  }
}
</script>

<style scoped>
.bk1 {
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.77);
  display: none;
}
.openImg {
  display: none;
  position: absolute;
  z-index: 12;
}
.openImg .a {
  width: 4.2667vw;
  height: 4.2667vw;
  float: right;
  margin-left: 91.4667vw;
  background-image: url(../assets/img/icon_close@2x.png);
  background-size: 100% 100%;
}
.openImg .all {
  margin-top: 12vw;
  margin-left: 4vw;
  width: 92vw;
  background-color: #ffffff;
}
.openImg .all span {
  display: block;
  padding-left: 8vw;
  font-size: 3.7333vw;
  color: rgba(0, 0, 0, 0.58);
  line-height: 10.6667vw;
  height: 10.6667vw;
}
.openImg .all table {
  border-collapse: collapse;
  width: 84vw;
  margin-left: 4vw;
}

tr {
  border-bottom: 0.2667vw dashed #000000;
}
th {
  width: 22.1333vw;
  height: 10.6667vw;
  pdding-left: 4vw;
  color: rgba(0, 0, 0, 0.58);
  opacity: 0.58;
  font-size: 3.2vw;
  line-height: 10.6667vw;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
}

td {
  text-align: center;
  vertical-align: middle;
}
td div {
  width: 22.1333vw;
  height: 10.6667vw;
  pdding-left: 4vw;
  opacity: 0.58;
  font-size: 3.2vw;
  line-height: 10.6667vw;
  text-align: center;
  vertical-align: middle;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
  overflow: hidden;
}
.bk {
  position: relative;
  width: 100vw;
  height: 34.6667vw;
  background-image: url(../assets/img/智能安防_banner_mob.png);
  background-size: 100% 100%;
}
.top {
  position: relative;
  width: 100vw;
  height: 53.3333vw;
}
.top .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 16.6667vw;
  color: #140047;
  letter-spacing: 1.8293vw;
  line-height: 8vw;
  font-size: 6.4vw;
}
.top .content {
  padding-top: 29.3333vw;
  text-align: center;
  margin-left: 5.3333vw;
  width: 89.3333vw;
  height: 16vw;
  opacity: 0.72;
  font-size: 3.2vw;
  letter-spacing: 0.1333vw;
  line-height: 5.3333vw;
  color: #01021b;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.top .smart {
  position: absolute;
  left: 10.4vw;
  top: 7.8667vw;
  color: #fafafa;
  font-size: 21.3333vw;
  letter-spacing: 0.64vw;
  line-height: 24.5333vw;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  z-index: -1;
}
.topImg {
  background-image: url(../assets/img/智能安防_下载资源1_mob.png);
  background-size: 100% 100%;
  margin: 5.3333vw auto 0;
  width: 92vw;
  height: 69.0667vw;
  /* border: 1px dashed #808080; */
}

.cecurity {
  position: relative;
  margin: 14.6667vw auto 0;
  width: 92vw;
  height: 42.1333vw;
  box-shadow: 0px 0.2667vw 2.6667vw 0px rgba(176, 183, 213, 0.2);
}

.cecurity .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
}
.cecurity .content {
  text-align: center;
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
  opacity: 0.72;
}
.cecurity .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}
.cecurityImg {
  width: 92vw;
  height: 68.8vw;
  margin: 5.3333vw auto 0;
  background-image: url(../assets/img/智能安防_下载资源2_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}

.cecurity2 {
  position: relative;
  margin: 14.6667vw auto 0;
  width: 92vw;
  height: 42.1333vw;
  box-shadow: 0px 0.2667vw 2.6667vw 0px rgba(176, 183, 213, 0.2);
}

.cecurity2 .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
}
.cecurity2 .content {
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
  opacity: 0.72;
}
.cecurity2 .content span {
  text-align: center;
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}
.cecurity2Img {
  width: 92vw;
  height: 68.8vw;
  margin: 5.3333vw auto 0;
  background-image: url(../assets/img/智能安防_下载资源2_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}

.bottom {
  position: relative;
  margin: 14.6667vw auto 0;
  width: 92vw;
  height: 42.1333vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.bottom .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
}
.bottom .content {
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
  opacity: 0.72;
}
.bottom .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}
.phone {
  margin-top: 4.2667vw;
  text-align: center;
  letter-spacing: 0.1333vw;
  line-height: 4.4vw;
  font-size: 3.2vw;
  color: #140047;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.address {
  margin-top: 2.1333vw;
  text-align: center;
  letter-spacing: 0.1333vw;
  line-height: 4.4vw;
  font-size: 3.2vw;
  color: #140047;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.down {
  margin-top: 4.2667vw;
  margin-left: 35.3333vw;
  width: 29.3333vw;
  height: 8vw;
  border-radius: 0.5333vw;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #140047;
}
.down span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
  float: left;
}
.down img {
  float: left;
  width: 8vw;
  height: 8.5333vw;
  margin-left: 2.6667vw;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor.vue